import { render, staticRenderFns } from "./SchoolCreateSchoolCosts.vue?vue&type=template&id=a60305b4&"
import script from "./SchoolCreateSchoolCosts.vue?vue&type=script&lang=ts&"
export * from "./SchoolCreateSchoolCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports